import * as types from './mutation-types';

export default {
  [types.SET_USED_TEF](state, payload) {
    state.usedTEF = payload;
  },
};
